import ListUtils from "@/lib/listUtils";
import EmailTemplateType from "@/models/EmailTemplates/EmailTemplateType";

export default (value: EmailTemplateType) => {
    return ListUtils.emailTemplateNameByType(value);
} 